import { useRef, useCallback, useEffect } from 'react';

export default function useLongPress(onLongPress: any, { ms = 500, disabled = false } = {}) {
	const timerRef = useRef<number | undefined>(undefined);
	const callbackRef = useRef(onLongPress);

	useEffect(() => {
		callbackRef.current = onLongPress;
	}, [onLongPress]);

	const startPress = useCallback(
		(e: any) => {
			if (disabled) return;
			if (e && typeof e.persist === 'function') e.persist();
			timerRef.current = window.setTimeout(() => {
				callbackRef.current(e);
			}, ms);
		},
		[ms, disabled]
	);

	const clearPress = useCallback(() => {
		clearTimeout(timerRef.current);
	}, []);

	return {
		onMouseDown: startPress,
		onTouchStart: startPress,
		onMouseUp: clearPress,
		onMouseLeave: clearPress,
		onTouchEnd: clearPress,
		onTouchMove: clearPress,
		onMouseMove: clearPress,
	};
}
